<template>
  <div class="komunitas-page">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading Komunitas Kami..."
    />

    <div v-else class="page-content">
      <AppHeader />

      <section class="hero-section">
        <div class="hero-container">
          <div class="hero-content">
            <h1 class="hero-title">
              Yuk, Berkenalan Dengan<br>
              <span class="hero-highlight">Komunitas Kami!</span>
            </h1>
          </div>
        </div>
      </section>

      <section class="communities-gallery">
        <div class="section-container">
          <div class="gallery-grid desktop-layout">
            <div class="gallery-item large">
              <img src="@/assets/ibu-canggih-1.svg" alt="Ibu2Canggih Community" class="gallery-image" />
            </div>
            <div class="gallery-item large">
              <img src="@/assets/ibu-canggih-2.svg" alt="Ibu2Canggih Event" class="gallery-image" />
            </div>
            <div class="community-info">
              <div class="community-logo">
                <img src="@/assets/ibu-canggih.png" alt="Ibu2Canggih" class="logo-img" />
              </div>
              <p class="community-desc">
                Komunitas para ibu modern & serba bisa 
                untuk saling belajar, berdaya, dan 
                bertumbuh bersama.
              </p>
            </div>

            <div class="community-info left">
              <div class="community-brand">
                <img src="@/assets/geng-glowing.png" alt="Geng Glowing" class="community-logo-img" />
              </div>
              <p class="community-desc">
                Komunitas yang fokus memberikan tips, 
                ulasan, dan edukasi mengenai kesehatan 
                kulit dan kecantikan.
              </p>
            </div>
            <div class="gallery-item large">
              <img src="@/assets/gg-1.svg" alt="Geng Glowing" class="gallery-image" />
            </div>
            <div class="gallery-item large">
              <img src="@/assets/gg-2.svg" alt="Geng Glowing Event" class="gallery-image" />
            </div>

            <div class="gallery-item large">
              <img src="@/assets/ikan-galau-1.svg" alt="Ikan Galau" class="gallery-image" />
            </div>
            <div class="gallery-item large">
              <img src="@/assets/ikan-galau-2.svg" alt="Ikan Galau Event" class="gallery-image" />
            </div>
            <div class="community-info">
              <div class="community-brand">
                <img src="@/assets/ikan-galau.png" alt="Ikan Galau" class="community-logo-img" />
              </div>
              <p class="community-desc">
                Talent agency di mana Creators-nya 
                dikembangkan menjadi komunitas untuk 
                sharing dan berkolaborasi dengan brands.
              </p>
            </div>
          </div>

          <div class="mobile-layout">
            <div class="mobile-community-section">
              <div class="mobile-community-header">
                <div class="mobile-community-logo">
                  <img src="@/assets/ibu-canggih.png" alt="Ibu2Canggih" class="mobile-logo-img" />
                </div>
                <p class="mobile-community-desc">
                  Komunitas para ibu modern & serba bisa 
                  untuk saling belajar, berdaya, dan 
                  bertumbuh bersama.
                </p>
              </div>
              <div class="mobile-gallery-images">
                <div class="mobile-gallery-item">
                  <img src="@/assets/ibu-canggih-1.svg" alt="Ibu2Canggih Community" class="mobile-gallery-image" />
                </div>
                <div class="mobile-gallery-item">
                  <img src="@/assets/ibu-canggih-2.svg" alt="Ibu2Canggih Event" class="mobile-gallery-image" />
                </div>
              </div>
            </div>

            <div class="mobile-community-section">
              <div class="mobile-community-header">
                <div class="mobile-community-logo">
                  <img src="@/assets/geng-glowing.png" alt="Geng Glowing" class="mobile-logo-img" />
                </div>
                <p class="mobile-community-desc">
                  Komunitas yang fokus memberikan tips, 
                  ulasan, dan edukasi mengenai kesehatan 
                  kulit dan kecantikan.
                </p>
              </div>
              <div class="mobile-gallery-images">
                <div class="mobile-gallery-item">
                  <img src="@/assets/gg-1.svg" alt="Geng Glowing" class="mobile-gallery-image" />
                </div>
                <div class="mobile-gallery-item">
                  <img src="@/assets/gg-2.svg" alt="Geng Glowing Event" class="mobile-gallery-image" />
                </div>
              </div>
            </div>

            <div class="mobile-community-section">
              <div class="mobile-community-header">
                <div class="mobile-community-logo">
                  <img src="@/assets/ikan-galau.png" alt="Ikan Galau" class="mobile-logo-img" />
                </div>
                <p class="mobile-community-desc">
                  Talent agency di mana Creators-nya 
                  dikembangkan menjadi komunitas untuk 
                  sharing dan berkolaborasi dengan brands.
                </p>
              </div>
              <div class="mobile-gallery-images">
                <div class="mobile-gallery-item">
                  <img src="@/assets/ikan-galau-1.svg" alt="Ikan Galau" class="mobile-gallery-image" />
                </div>
                <div class="mobile-gallery-item">
                  <img src="@/assets/ikan-galau-2.svg" alt="Ikan Galau Event" class="mobile-gallery-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="services-section">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Servis Komunitas Kami</h2>
          </div>
          
          <div class="services-grid">
            <div class="service-item">
              <div class="service-image">
                <img src="@/assets/service-1.svg" alt="Social Media Content Placement" class="service-img" />
              </div>
              <h3 class="service-title">Social Media Content Placement</h3>
            </div>
            
            <div class="service-item">
              <div class="service-image">
                <img src="@/assets/influencer-visit.jpg" alt="Influencer Visit and Product Review" class="service-img" />
              </div>
              <h3 class="service-title">Influencer Visit and Product Review</h3>
            </div>
            
            <div class="service-item">
              <div class="service-image">
                <img src="@/assets/service-3.svg" alt="Instagram Live and Webinar" class="service-img" />
              </div>
              <h3 class="service-title">Instagram Live and Webinar</h3>
            </div>
            
            <div class="service-item">
              <div class="service-image">
                <img src="@/assets/service-4.svg" alt="Kuliah WhatsApp (KulWhap)" class="service-img" />
              </div>
              <h3 class="service-title">Kuliah WhatsApp (KulWhap)</h3>
            </div>
            
            <div class="service-item">
              <div class="service-image">
                <img src="@/assets/giveaway-survey.jpg" alt="Giveaway, Survey, and Product Sampling" class="service-img" />
              </div>
              <h3 class="service-title">Giveaway, Survey, and Product Sampling</h3>
            </div>
            
            <div class="service-item">
              <div class="service-image">
                <img src="@/assets/service-6.svg" alt="TikTok Live Shopping" class="service-img" />
              </div>
              <h3 class="service-title">TikTok Live Shopping</h3>
            </div>
          </div>
        </div>
      </section>

      <!-- Portfolio Section - Commented for future use -->
      <!-- 
      <section class="portfolio-section">
        <div class="section-container">
          <div class="portfolio-wrapper">
            
            <button class="carousel-btn prev-floating" @click="prevPortfolio">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15,18 9,12 15,6"></polyline>
              </svg>
            </button>

            <div class="portfolio-slider-container">
              <div 
                class="portfolio-slider" 
                :style="{ 
                  transform: `translateX(${portfolioTranslateX}px)`,
                  transition: `transform ${transitionDuration}s ease` 
                }"
              >
                <div 
                  v-for="item in portfolioItems" 
                  :key="`real-${item.id}`"
                  class="portfolio-item"
                  :style="{ width: portfolioItemWidth + 'px' }"
                >
                  <div class="portfolio-card">
                    <img :src="item.image" :alt="item.title" class="portfolio-image" />
                  </div>
                </div>

                <div 
                  v-for="item in portfolioItems" 
                  :key="`dup-${item.id}`"
                  class="portfolio-item"
                  :style="{ width: portfolioItemWidth + 'px' }"
                >
                  <div class="portfolio-card">
                    <img :src="item.image" :alt="item.title" class="portfolio-image" />
                  </div>
                </div>
              </div>
            </div>
            
            <button class="carousel-btn next-floating" @click="nextPortfolio">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9,18 15,12 9,6"></polyline>
              </svg>
            </button>

          </div>
        </div>
      </section>
      -->

      <!-- Articles Section -->
      <section class="articles-section">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Artikel Terbaru</h2>
          </div>
          
          <div v-if="articles.length > 0">
            <!-- Single Article - Featured Layout -->
            <div v-if="articles.length === 1" class="articles-featured">
              <div class="featured-article-card">
                <div class="featured-article-image">
                  <img :src="articles[0].image || require('@/assets/cta-background.png')" :alt="articles[0].title" class="featured-article-photo" />
                  <div class="featured-article-overlay">
                    <div class="featured-article-category">Artikel Terbaru</div>
                  </div>
                </div>
                
                <div class="featured-article-content">
                  <div class="featured-article-header">
                    <h3 class="featured-article-title">{{ articles[0].title }}</h3>
                  </div>
                  
                  <div class="featured-article-footer">
                    <a :href="articles[0].link" target="_blank" rel="noopener noreferrer" class="featured-read-more-button">
                      <span>Baca Selengkapnya</span>
                      <i class="mdi mdi-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- 2-3 Articles - Grid Layout -->
            <div v-else-if="articles.length <= 3" class="articles-grid">
              <div v-for="(article, index) in articles" :key="index" class="article-card">
                <div class="article-image">
                  <img :src="article.image || require('@/assets/cta-background.png')" :alt="article.title" class="article-photo" />
                  <div class="article-overlay">
                    <div class="article-category">Artikel</div>
                  </div>
                </div>
                
                <div class="article-content">
                  <div class="article-header">
                    <h4 class="article-title">{{ article.title }}</h4>
                  </div>
                  
                  <div class="article-footer">
                    <a :href="article.link" target="_blank" rel="noopener noreferrer" class="read-more-button">
                      <span>Selengkapnya</span>
                      <i class="mdi mdi-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- >3 Articles - Carousel Layout -->
            <div v-else class="articles-carousel">
              <div class="articles-wrapper">
                
                <button class="carousel-btn prev-floating" @click="prevArticles" :disabled="articleIndex === 0">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15,18 9,12 15,6"></polyline>
                  </svg>
                </button>

                <div class="articles-slider-container">
                  <div 
                    class="articles-slider" 
                    :style="{ 
                      transform: `translateX(${articleTranslateX}px)`,
                      transition: `transform ${articleTransitionDuration}s ease` 
                    }"
                  >
                    <div 
                      v-for="(article, index) in articles" 
                      :key="index"
                      class="articles-item"
                      :style="{ width: articleItemWidth + 'px' }"
                    >
                      <div class="article-card">
                        <div class="article-image">
                          <img :src="article.image || require('@/assets/cta-background.png')" :alt="article.title" class="article-photo" />
                          <div class="article-overlay">
                            <div class="article-category">Artikel</div>
                          </div>
                        </div>
                        
                        <div class="article-content">
                          <div class="article-header">
                            <h4 class="article-title">{{ article.title }}</h4>
                          </div>
                          
                          <div class="article-footer">
                            <a :href="article.link" target="_blank" rel="noopener noreferrer" class="read-more-button">
                              <span>Selengkapnya</span>
                              <i class="mdi mdi-arrow-right"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <button class="carousel-btn next-floating" @click="nextArticles" :disabled="articleIndex >= maxArticleIndex">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9,18 15,12 9,6"></polyline>
                  </svg>
                </button>

              </div>
            </div>
          </div>

          <!-- Empty State for Articles -->
          <div v-else class="articles-empty-state">
            <div class="empty-state-content">
              <div class="empty-state-icon">
                <i class="mdi mdi-newspaper-variant-outline"></i>
              </div>
              <h3 class="empty-state-title">Belum Ada Artikel</h3>
              <p class="empty-state-description">
                Saat ini belum ada artikel yang tersedia. Silakan cek kembali nanti untuk membaca artikel-artikel menarik.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="cta-section">
        <div class="cta-container">
          <div class="cta-content">
            <h2 class="cta-title">Tertarik Untuk Bekerja Sama?</h2>
            <bert-button variant="outline" size="lg" class="cta-button"  @click="contactUs('Halo Admin, saya berminat untuk daftar jadi Brand Partner. Bagaimana caranya?')">
              Klik Disini!
            </bert-button>
          </div>
        </div>
      </section>

      <section class="empty-section">

      </section>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import BertButton from './ui/Button.vue'
import BertLoading from './ui/Loading.vue'
import Header from './layout/Header.vue'
import Footer from './layout/Footer.vue'

export default {
  name: 'KomunitasKami',
  components: {
    BertButton,
    BertLoading,
    AppHeader: Header,
    AppFooter: Footer
  },
  data() {
    return {
      isLoading: false,
      isMobile: false,
      articles: [], // Added for articles
      
      // Article Carousel State
      articleTranslateX: 0,
      articleItemWidth: 0,
      articleIndex: 0,
      articleTransitionDuration: 0.3,
      isArticleAnimating: false,
      
      // Portfolio Carousel State (commented for future use)
      portfolioTranslateX: 0,
      portfolioItemWidth: 0,
      portfolioIndex: 0,
      transitionDuration: 0.3,
      isAnimating: false,

      portfolioItems: [
        {
          id: 0,
          title: 'Portfolio 0',
          image: require('@/assets/product-0.svg')
        },
        {
          id: 1,
          title: 'Portfolio 1',
          image: require('@/assets/product-1.svg')
        },
        {
          id: 2,
          title: 'Portfolio 2',
          image: require('@/assets/product-2.svg')
        },
        {
          id: 3,
          title: 'Portfolio 3',
          image: require('@/assets/product-3.svg')
        },
        {
          id: 4,
          title: 'Portfolio 4',
          image: require('@/assets/product-4.svg')
        },
      ]
    }
  },
  computed: {
    maxArticleIndex() {
      const itemsVisible = this.isMobile ? 1 : 3;
      return Math.max(0, this.articles.length - itemsVisible);
    }
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768
      this.calculatePortfolioItemWidth()
      this.calculateArticleItemWidth()
    },
    calculatePortfolioItemWidth() {
      this.$nextTick(() => {
        const container = this.$el?.querySelector('.portfolio-slider-container')
        if (container) {
          const containerWidth = container.offsetWidth
          const itemsVisible = this.isMobile ? 1 : 4 
          this.portfolioItemWidth = containerWidth / itemsVisible
          this.portfolioTranslateX = -(this.portfolioIndex * this.portfolioItemWidth)
        }
      })
    },
    
    // --- Infinite Slider Logic ---
    nextPortfolio() {
      if (this.isAnimating) return
      this.isAnimating = true

      const itemsToMove = 1
      this.portfolioIndex += itemsToMove
      this.portfolioTranslateX -= this.portfolioItemWidth * itemsToMove

      // Check if we reached the duplicate set
      if (this.portfolioIndex >= this.portfolioItems.length) {
        setTimeout(() => {
          // Disable animation (snap)
          this.transitionDuration = 0
          
          // Snap back to start
          this.portfolioIndex = 0
          this.portfolioTranslateX = 0

          // Re-enable animation
          setTimeout(() => {
            this.transitionDuration = 0.3
            this.isAnimating = false
          }, 50)
        }, 300)
      } else {
        setTimeout(() => {
          this.isAnimating = false
        }, 300)
      }
    },
    prevPortfolio() {
      if (this.isAnimating) return
      this.isAnimating = true

      // If at start, snap to the end of duplicate set first
      if (this.portfolioIndex <= 0) {
        this.transitionDuration = 0
        this.portfolioIndex = this.portfolioItems.length
        this.portfolioTranslateX = -this.portfolioItemWidth * this.portfolioItems.length

        setTimeout(() => {
          this.transitionDuration = 0.3
          
          // Now slide back one item
          this.portfolioIndex -= 1
          this.portfolioTranslateX += this.portfolioItemWidth
          
          setTimeout(() => {
            this.isAnimating = false
          }, 300)
        }, 50)
      } else {
        this.portfolioIndex -= 1
        this.portfolioTranslateX += this.portfolioItemWidth
        setTimeout(() => {
          this.isAnimating = false
        }, 300)
      }
    },
    // ----------------------------

    // Article Carousel Methods
    calculateArticleItemWidth() {
      this.$nextTick(() => {
        const container = this.$el?.querySelector('.articles-slider-container')
        if (container) {
          const containerWidth = container.offsetWidth
          const itemsVisible = this.isMobile ? 1 : 3 
          this.articleItemWidth = containerWidth / itemsVisible
          this.articleTranslateX = -(this.articleIndex * this.articleItemWidth)
        }
      })
    },

    nextArticles() {
      if (this.isArticleAnimating) return
      this.isArticleAnimating = true

      const itemsToMove = 1
      this.articleIndex += itemsToMove
      this.articleTranslateX -= this.articleItemWidth * itemsToMove

      // Check if we reached the end
      if (this.articleIndex > this.maxArticleIndex) {
        this.articleIndex = this.maxArticleIndex
        this.articleTranslateX = -(this.articleIndex * this.articleItemWidth)
      }

      setTimeout(() => {
        this.isArticleAnimating = false
      }, 300)
    },

    prevArticles() {
      if (this.isArticleAnimating) return
      this.isArticleAnimating = true

      const itemsToMove = 1
      this.articleIndex -= itemsToMove
      this.articleTranslateX += this.articleItemWidth * itemsToMove

      // Check if we reached the beginning
      if (this.articleIndex < 0) {
        this.articleIndex = 0
        this.articleTranslateX = 0
      }

      setTimeout(() => {
        this.isArticleAnimating = false
      }, 300)
    },

    loadArticles() {
      const baseURI = this.$settings.endPoint + "get-article";
      this.isLoading = true;
      return this.$http
        .get(
          baseURI +
          `?limit=10&page=1&sort_field=&sort_type=&title=&link=&priority=`,
          {
            timeout: 10000,
            'headers': {
              'AppToken': this.$settings.jwtSecret,
            }
          }
        )
        .then((response) => {
          this.isLoading = false;
          this.articles = response.data.datas || [];
          console.log('Articles loaded:', this.articles.length, this.articles)
          // Recalculate carousel after articles are loaded
          this.$nextTick(() => {
            this.calculateArticleItemWidth();
          });
        }).catch(error => {
          this.isLoading = false;
          console.log('Error loading articles:', error);
          this.handleError(error);
        });
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          console.error('Validation error:', error.response.data.errors);
        } else if (error.response.status === 500) {
          console.error('Server error');
        } else if (error.response.status === 401) {
          console.error('Unauthorized error');
        } else {
          console.error('Page not found');
        }
      }
    },

    loading() {
      this.checkScreenSize()
      window.addEventListener('resize', this.checkScreenSize)
      // Load articles when component loads
      this.loadArticles()
      // Article carousel calculation
      setTimeout(() => {
          this.calculateArticleItemWidth()
      }, 100)
      // Portfolio calculation (commented for future use)
      setTimeout(() => {
          this.calculatePortfolioItemWidth()
      }, 100)
    },
    contactUs(message) {
      const phoneNumber = "628115674433"; 
      const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
      window.location.href = url;
    },

  },
  mounted() {
    this.loading()
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  }
}
</script>

<style scoped>
.komunitas-page {
  min-height: 100vh;
  background: #F5F5F5;
}

.page-content {
  width: 100%;
}

/* Hero Section */
.hero-section {
  padding: var(--space-20) 0;
  background: white;
}

.hero-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
  text-align: center;
}

.hero-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  align-items: center;
}

.hero-title {
  font-size: 4.5rem;
  font-weight: var(--font-bold);
  line-height: 1.2;
  margin: 0;
  color: var(--text-dark);
}

.hero-highlight {
  color: var(--yellow-main);
}

/* Communities Gallery */
.communities-gallery {
  padding: var(--space-16) 0;
  background: white;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

/* Desktop Layout */
.desktop-layout {
  display: block;
}

.mobile-layout {
  display: none;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-6);
  align-items: center;
}

.gallery-item {
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-md);
}

.gallery-item.large {
  grid-row: span 1;
}

.gallery-item.medium {
  aspect-ratio: 1;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.community-info {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-6);
}

.community-info.left {
  text-align: left;
}

.community-logo {
  width: 80px;
  height: 80px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-sm);
}

.logo-img {
  width: 60px;
  height: auto;
  object-fit: contain;
}

.community-brand {
  margin-bottom: var(--space-4);
}

.community-logo-img {
  width: 120px;
  height: auto;
  object-fit: contain;
}

.community-name {
  font-size: var(--text-2xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0;
  line-height: 1.2;
}

.community-name.purple {
  color: var(--purple-medium);
}

.community-desc {
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--text-dark-grey);
  margin: 0;
}

/* Mobile Layout Styles */
.mobile-community-section {
  margin-bottom: var(--space-12);
  text-align: center;
}

.mobile-community-header {
  margin-bottom: var(--space-6);
}

.mobile-community-logo {
  display: flex;
  justify-content: center;
  margin-bottom: var(--space-4);
}

.mobile-logo-img {
  width: 120px;
  height: auto;
  object-fit: contain;
}

.mobile-community-desc {
  font-size: var(--text-base);
  line-height: 1.6;
  color: var(--text-dark-grey);
  margin: 0;
  padding: 0 var(--space-4);
}

.mobile-gallery-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

.mobile-gallery-item {
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  aspect-ratio: 1;
}

.mobile-gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Services Section */
.services-section {
  padding: var(--space-20) 0;
  background: var(--blue-soft);
}

.section-header {
  text-align: center;
  margin-bottom: var(--space-12);
}

.section-title {
  font-size: var(--text-3xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-8);
}

.service-item {
  text-align: center;
}

.service-image {
  width: 100%;
  height: 280px; /* Portrait height - taller than width */
  border-radius: var(--radius-lg);
  overflow: hidden;
  margin-bottom: var(--space-4);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.service-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.service-title {
  font-size: var(--text-lg);
  font-weight: var(--font-semibold);
  color: var(--text-dark);
  margin-top: 24px;
  line-height: 1.4;
}

/* Portfolio Section (Updated to Infinite Slider) */
/* Portfolio Section */
.portfolio-section {
  padding: var(--space-16) 0;
  background: white;
}

.portfolio-wrapper {
  position: relative;
  padding: 0 var(--space-4);
}

.portfolio-slider-container {
  overflow: hidden;
  width: 100%;
  padding: var(--space-2) 0;
}

.portfolio-slider {
  display: flex;
  /* CHANGED: Remove width: 200%. Let it grow naturally based on content */
  width: max-content; 
  /* Ensure items don't wrap */
  flex-wrap: nowrap; 
}

.portfolio-item {
  /* CHANGED: Remove flex: 0 0 25%. Width is now handled via inline style in Template */
  flex-shrink: 0; 
  padding: 0 var(--space-2);
  box-sizing: border-box;
}

.portfolio-card {
  width: 100%;
  aspect-ratio: 4/3; 
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s ease;
}

.portfolio-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.portfolio-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Floating Buttons */
.carousel-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--yellow-main);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-base);
  
  /* Floating Logic */
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.carousel-btn:hover {
  background: var(--yellow-soft);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.prev-floating {
  left: -24px;
}

.next-floating {
  right: -24px;
}

/* Articles Section */
.articles-section {
  padding: var(--space-16) 0;
  background: white;
}

/* Featured Article Layout (1 article) */
.articles-featured {
  display: flex;
  justify-content: center;
}

.featured-article-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-8);
  max-width: 800px;
  width: 100%;
  background: white;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
  transition: all 0.3s ease;
}

.featured-article-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
}

.featured-article-image {
  position: relative;
  height: 300px;
  overflow: hidden;
}

.featured-article-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.featured-article-card:hover .featured-article-photo {
  transform: scale(1.05);
}

.featured-article-overlay {
  position: absolute;
  top: 20px;
  left: 20px;
}

.featured-article-category {
  background: rgba(249, 166, 25, 0.9);
  color: white;
  padding: 8px 16px;
  border-radius: 25px;
  font-size: 0.9rem;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

.featured-article-content {
  padding: var(--space-8);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.featured-article-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 var(--space-6) 0;
  line-height: 1.3;
}

.featured-article-footer {
  margin-top: auto;
}

.featured-read-more-button {
  background: var(--yellow-main);
  color: white;
  text-decoration: none;
  padding: 14px 28px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}

.featured-read-more-button:hover {
  background: var(--yellow-soft);
  color: white;
  text-decoration: none;
  transform: translateY(-2px);
}

/* Grid Layout (2-3 articles) */
.articles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--space-6);
}

.article-card {
  background: white;
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  height: 320px; /* Fixed height for consistency */
  display: flex;
  flex-direction: column;
}

.article-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.article-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.article-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.article-card:hover .article-photo {
  transform: scale(1.05);
}

.article-overlay {
  position: absolute;
  top: 16px;
  left: 16px;
}

.article-category {
  background: rgba(249, 166, 25, 0.9);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

.article-content {
  padding: 20px;
  flex: 1; /* Takes remaining space */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Distributes space evenly */
}

.article-header {
  margin-bottom: 16px;
}

.article-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Allow up to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 4.2rem; /* Fixed height for 3 lines (1.4 * 1.1rem * 3) */
}

.article-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid #F3F4F6;
}

.read-more-button {
  background: var(--yellow-main);
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.read-more-button:hover {
  background: var(--yellow-soft);
  color: white;
  text-decoration: none;
  transform: translateY(-1px);
}

.read-more-button i {
  font-size: 1rem;
}

/* Carousel Layout (>3 articles) - Based on Portfolio Section */
.articles-carousel {
  background: white;
}

.articles-wrapper {
  position: relative;
  padding: 0 var(--space-4);
}

.articles-slider-container {
  overflow: hidden;
  width: 100%;
  padding: var(--space-2) 0;
}

.articles-slider {
  display: flex;
  width: max-content; 
  flex-wrap: nowrap; 
}

.articles-item {
  flex-shrink: 0; 
  padding: 0 var(--space-2);
  box-sizing: border-box;
}

/* Floating Buttons */
.carousel-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--yellow-main);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-base);
  
  /* Floating Logic */
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.carousel-btn:hover:not(:disabled) {
  background: var(--yellow-soft);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 12px rgba(0,0,0,0.15);
}

.carousel-btn:disabled {
  background: #E5E7EB;
  color: #9CA3AF;
  cursor: not-allowed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.prev-floating {
  left: -24px;
}

.next-floating {
  right: -24px;
}

/* Articles Empty State */
.articles-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 40px 20px;
}

.empty-state-content {
  text-align: center;
  max-width: 400px;
}

.empty-state-icon {
  margin-bottom: 24px;
}

.empty-state-icon i {
  font-size: 4rem;
  color: #D1D5DB;
}

.empty-state-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
  margin: 0 0 12px 0;
}

.empty-state-description {
  font-size: 1rem;
  color: #6B7280;
  line-height: 1.6;
  margin: 0;
}

.empty-section {
  height: 120px;
  background-color: white;
}

/* CTA Section */
.cta-section {
  padding: 40px 20px;
  background-color: white; /* Space around the card */
}

.cta-container {
  max-width: 1100px;
  margin: 0 auto;
  /* Apply background image here */
  background: #F9A619 url('@/assets/cta-background.png') no-repeat center center;
  background-size: cover;
  border-radius: 20px; /* Rounded corners for the card */
  padding: 60px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: 0 10px 30px rgba(249, 166, 25, 0.2);
}

.cta-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.cta-title {
  color: #2B2F3C;
  font-size: 32px;
  font-weight: 800;
  margin: 0;
  line-height: 1.2;
}

/* Style for the button to make it pop against the orange */
.cta-button {
  background-color: white !important;
  color: #2B2F3C !important;
  border-radius: 50px;
  padding: 12px 40px;
  font-weight: 700;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
}

.footer {
  margin-top: 100px;
}

/* Responsive Design */
@media (max-width: 768px) {
  
  .section-container {
    padding: 0 var(--space-4);
  }

  .hero-section {
    padding: var(--space-6) 0;
    background: white;
  }
  
  .communities-gallery {
    padding: var(--space-6) 0;
    background: white;
  }

  .desktop-layout {
    display: none;
  }
  
  .mobile-layout {
    display: block;
  }

  .hero-title {
    font-size: var(--text-3xl);
    line-height: 1.3;
  }
  
  .gallery-grid {
    grid-template-columns: 1fr;
    gap: var(--space-4);
  }
  
  .gallery-item.large {
    grid-row: span 1;
  }
  
  .community-info {
    padding: var(--space-4);
    text-align: center;
  }
  
  .community-name {
    font-size: var(--text-xl);
  }
  
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--space-4);
  }
  
  .service-item {
    text-align: center;
  }
  
  .service-image {
    height: 200px; /* Shorter height for mobile but still portrait */
    margin-bottom: var(--space-3);
  }
  
  .service-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: var(--radius-lg);
  }
  
  .service-title {
    font-size: var(--text-sm);
    margin-top: var(--space-3);
    line-height: 1.3;
    padding: 0 var(--space-1);
  }
  
  .section-title {
    font-size: var(--text-2xl);
  }
  
  .prev-floating {
    left: 0;
  }

  .next-floating {
    right: 0;
  }
  
  .carousel-btn {
    width: 40px;
    height: 40px;
    opacity: 0.9;
  }
  
  .cta-title {
    font-size: var(--text-2xl);
  }

  /* Articles Mobile Styles */
  .articles-section {
    padding: var(--space-8) 0;
  }

  /* Featured Article Mobile */
  .featured-article-card {
    grid-template-columns: 1fr;
    max-width: none;
  }
  
  .featured-article-image {
    height: 200px;
  }
  
  .featured-article-content {
    padding: var(--space-4);
  }
  
  .featured-article-title {
    font-size: 1.25rem;
  }
  
  .featured-read-more-button {
    padding: 12px 24px;
    font-size: 0.9rem;
  }
  
  /* Grid Mobile */
  .articles-grid {
    grid-template-columns: 1fr;
    gap: var(--space-4);
  }
  
  .article-card {
    border-radius: var(--radius-lg);
    height: 280px; /* Fixed height for mobile consistency */
  }
  
  .article-image {
    height: 160px;
  }
  
  .article-content {
    padding: 16px;
  }
  
  .article-title {
    font-size: 1rem;
    min-height: 3rem; /* Fixed height for mobile (1.4 * 1rem * 2 lines) */
    -webkit-line-clamp: 2; /* 2 lines on mobile */
  }
  
  .read-more-button {
    padding: 8px 16px;
    font-size: 0.85rem;
  }

  /* Carousel Mobile */
  .articles-wrapper {
    padding: 0 var(--space-2);
  }
  
  .prev-floating {
    left: 0;
  }

  .next-floating {
    right: 0;
  }
  
  .carousel-btn {
    width: 40px;
    height: 40px;
    opacity: 0.9;
  }
  
  .articles-empty-state {
    min-height: 250px;
    padding: 20px 10px;
  }
  
  .empty-state-content {
    max-width: 300px;
  }
  
  .empty-state-icon i {
    font-size: 3rem;
  }
  
  .empty-state-title {
    font-size: 1.25rem;
  }
  
  .empty-state-description {
    font-size: 0.9rem;
  }
}
</style>